import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { RemoteRecordData } from '@client/common/redux/RemoteRecordData';
import { AppState } from '@client/common/redux/store';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = RemoteRecordData.getDefault();

const NAME = 'restockSubscribe';

export const restockSubscribeSlice = createSlice({
  name: NAME,
  reducerPath: NAME,
  initialState,
  reducers: {
    restockSubscribe: (state, action: PayloadAction<{ sku: number, email: string }>) => {
      state = RemoteRecordData.init();
      return state;
    },
    restockSubscribeFulfilled: (state) => {
      state = RemoteRecordData.fulfill({});
      return state;
    },
    restockSubscribeRejected: (state, action: PayloadAction<{ error: ErrorType }>) => {
      state = RemoteRecordData.reject(action.payload.error);
      return state;
    },
    clearRestockSubscribe: () => initialState,
  },
});

export const {
  restockSubscribe,
  restockSubscribeFulfilled,
  restockSubscribeRejected,
  clearRestockSubscribe,
} = restockSubscribeSlice.actions;

const getState = (state: AppState) => state.product.restockSubscribe;

export const selectRestockSubscribeData = createSelector(
  getState,
  (state) => new RemoteRecord<{ sku: number, email: string }>(state),
);
